import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { WidgetService } from '../widget.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { WidgetStatus } from '../../models/widget';
import { EditWidgetModalComponent } from 'app/widgets/edit-widget-modal/edit-widget-modal.component';
import { WidgetDetailInstanceService } from './widget-detail-instance.service';
import { AlertService } from '../../core/alert.service';
import { ModalService } from '../../core/modal.service';

@Component({
  selector: 'app-widget-detail',
  templateUrl: './widget-detail.component.html',
  providers: [WidgetDetailInstanceService]
})
export class WidgetDetailComponent implements OnInit, OnDestroy {
  isEditingMaps: boolean;
  activeTab: string = 'maps';
  @HostBinding('class') className = 'u-main-container';

  constructor(private widgetService: WidgetService,
              private route: ActivatedRoute,
              private router: Router,
              private modal: ModalService,
              private alert: AlertService,
              private instance: WidgetDetailInstanceService) {

  }

  ngOnInit() {
    this.instance.$error.subscribe(err => {
      this.alert.error(err.statusText);
      this.router.navigate(['..']);
    });

    this.route.params
      .subscribe((params: Params) => this.instance.loadWidget(+params['id']));
  }

  ngOnDestroy() {

  }

  onNameChange(name: string) {
    this.widget.name = name;
    this.widgetService.update(this.widget).subscribe(widget => {
      this.instance.reload();
    });
  }

  deleteWidget() {
    if (!confirm('Ta bort widget?')) {
      return;
    }

    this.widgetService.deleteWidget(this.widget)
      .subscribe(ok => {
        this.alert.success('Widget borttagen!');
        this.router.navigate(['..']);
      }, err => {
        this.alert.error(err.statusText);
      });
  }

  showEditModal() {
    const modalRef = this.modal.open(EditWidgetModalComponent);
    modalRef.componentInstance.initEdit(this.widget);
    modalRef.result.then(widget => {

    }).catch(() => {
    });
  }

  get statuses() {
    return
  }


  get templateSupportsSunstudies() {
    return this.widget.template.configuration.sunstudies;
  }


  get isDraft() {
    return this.widget.status === WidgetStatus.Draft;
  }

  get isArchived() {
    return this.widget.status === WidgetStatus.Archived;
  }

  get isPublished() {
    return this.widget.status === WidgetStatus.Published;
  }

  get widget() {
    return this.instance.widget;
  }

  get project() {
    return this.widget.project;
  }

  get availableStatuses() {
    return this.widgetService.availableStatuses;
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/widget-detail.component.ts